'use client';

import CardScroll from '@/components/ui/card-scroll';
import StickyCardScroll from '@/components/ui/sticky-card-scroll';
import { Vacature } from '@/payload-types';

type VacancyDetailProps = {
    vacancy: Vacature;
};

export default function VacancyDetail({ vacancy }: VacancyDetailProps) {
    return (
        <div>
            <div className="hidden lg:block">
                <StickyCardScroll vacancy={vacancy} />
            </div>
            <div className="mt-[54px] overflow-hidden lg:mt-[77px] lg:hidden">
                <CardScroll vacancy={vacancy} />
            </div>
        </div>
    );
}
